import { useState, useEffect, useContext } from 'react';

import { cmnContext } from '../../../../common/CmnContext';
import { PracticeReseveContext } from '../../PracticeReseveContext';


// 講師へのコメント
function PracticeReserveRequest() {

  const isPc = useContext(cmnContext).isPc;
  const {
    lessonTermMinute, lsnMin,
    requestContent, setRequestContent,
  } = useContext(PracticeReseveContext);

  const placeholderText = `●受講前に講師へお伝えしたい事がありましたらご記入ください。

●キッズプラクティスを選択された方は、『お子様の年齢』と『お子様のお名前』をご記入ください。（例：Hanako 9さい)
`;


  return (
    <div>

      <label htmlFor="memo" style={{
        backgroundColor: '#eaf3ff',
        padding: '0.25em 3em 0.25em 0.5em',
        borderLeft: 'solid 5px #516ab6',
      }}>講師へコメント</label>

      {(lsnMin == lessonTermMinute*2) &&
        <div className="alert alert-info small" style={{ padding: '10px', marginBottom: '10px' }}>
          30分レッスンを選択された場合、実践したい内容を2つまでお選びいただけます。<br />
          2つ選ばれる場合は、ご希望のミッショントピックを2つ、コメント欄にご記入ください。<br />
        </div>
      }

      <div style={{ marginBottom: '15px', fontSize: '90%' }}>
        <textarea
          className="form-control"
          style={{ fontSize: '16px' }}  //16px未満の場合：iOSで拡大される
          name="memo"
          placeholder={placeholderText}
          rows={isPc? 5 : 7}
          value={requestContent}
          onChange={(e) => setRequestContent(e.target.value)}
        ></textarea>
        <small>※予約変更、キャンセルはコメントではお受けしておりません</small>
      </div>

    </div>
  );
}
  
export default PracticeReserveRequest;